"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUANTITY = exports.PRICE = exports.FUNDING_STREAM_NAME = void 0;
var QUANTITY = 'quantity';
exports.QUANTITY = QUANTITY;
var PRICE = 'price';
exports.PRICE = PRICE;
var FUNDING_STREAM_NAME = {
  preAwardCosts: 'Pre-Award Costs',
  hiringOfFirefighters: 'Hiring of firefighters',
  recruitmentAndRetention: 'Recruitment and retention',
  firePreventionAndSafety: 'Fire prevention and safety',
  researchAndDevelopment: 'Research and development',
  plan: 'Plan',
  project: 'Project',
  operationsAndSafety: 'Operations and safety',
  vehicleAcquisition: 'Vehicle acquisition',
  nonConstruction: 'Non construction',
  construction: 'Construction',
  disasterCaseManagement: 'Disaster case management'
};
exports.FUNDING_STREAM_NAME = FUNDING_STREAM_NAME;